export default __webpack_public_path__ + "static/media/light_default_user-avatar.42ac0952.png";